export default "__VITE_ASSET__Cf5mF4ww__"